import * as React from 'react';
import { Component } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import styles from '../../styles/forms/attachment_wizard/AttachmentForm.scss';
import Button from '../../components/Button';
import Input from '../../components/Input';
import Select from '../../components/Select';
import Textarea from '../../components/Textarea';
import { __ } from '../../core/utils';

@reduxForm({
  form: 'attachment_wizard.edit_attachment',
})
class EditAttachmentForm extends Component {
  render() {
    return (
      <Form onSubmit={this.props.handleSubmit} className={styles.wrapper}>
        <div className={styles.form}>
          <Field
            name='title'
            component={Input}
            label={__('attachments.form.title')}
          />
          <Field
            name='description'
            component={Textarea}
            rows={5}
            maxRows={8}
            label={__('attachments.form.description')}
          />
          {this.props.categoryOptions && (
            <Field
              name='category'
              component={Select}
              searchable
              label={__('products.flyout.edit-specification-file-category')}
              options={this.props.categoryOptions}
            />
          )}
        </div>
        <div className={styles.footer}>
          <Button
            lightGray
            medium
            left
            middleText={__('button.cancel')}
            onClick={this.props.onClose}
          />
          <Button
            lightBlue
            medium
            right
            submit
            middleText={__('button.edit')}
            spinning={this.props.submitting}
          />
        </div>
      </Form>
    );
  }
}

export default EditAttachmentForm;
